// extracted by mini-css-extract-plugin
export var label = "_gc-2";
export var slideContainer = "_gc-0";
export var slider = "_gc-1";